(() => {
  const ROOT_SELECTOR = '.fleximaa-standard-collection-grid';
  const ITEM_SELECTOR = '.facet-checkbox, .mobile-facets__label';
  let syncQueued = false;
  const observedRoots = new WeakSet();

  const resultCount = (root) => {
    const source = root.querySelector('#ProductCountDesktop') || root.querySelector('#ProductCount');
    const match = source?.textContent?.match(/[\d,]+/);
    if (!match) return null;
    const count = Number.parseInt(match[0].replace(/,/g, ''), 10);
    return Number.isFinite(count) ? count : null;
  };

  const syncCounts = (root) => {
    const count = resultCount(root);
    if (count === null) return;
    const noun = count === 1 ? 'product' : 'products';

    root.querySelectorAll('[data-fleximaa-mobile-filter-show-count], .mobile-facets__footer .button.button--primary').forEach((element) => {
      const text = `Show ${count} ${noun}`;
      if (element.textContent.trim() !== text) element.textContent = text;
    });

    root.querySelectorAll('.mobile-facets__count').forEach((element) => {
      const text = `${count} ${noun}`;
      if (element.textContent.trim() !== text) element.textContent = text;
    });
  };

  const syncSelections = (root) => {
    root.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      const checkbox = item.querySelector('input[type="checkbox"]');
      if (!checkbox) return;
      item.classList.toggle('is-checked', checkbox.checked);
      item.classList.remove('is-pending-selected');
    });
  };

  const queueSync = () => {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(() => {
      syncQueued = false;
      const root = document.querySelector(ROOT_SELECTOR);
      if (!root) return;
      syncCounts(root);
      syncSelections(root);
    });
  };

  const init = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    syncCounts(root);
    syncSelections(root);

    new MutationObserver(queueSync).observe(root, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  document.addEventListener('pointerdown', (event) => {
    const root = event.target.closest(ROOT_SELECTOR);
    const item = event.target.closest(ITEM_SELECTOR);
    if (!root || !item || !root.contains(item)) return;
    const checkbox = item.querySelector('input[type="checkbox"]');
    if (!checkbox || checkbox.disabled) return;
    item.classList.toggle('is-pending-selected', !checkbox.checked);
    item.classList.toggle('is-checked', !checkbox.checked);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches(`${ROOT_SELECTOR} input[type="checkbox"]`)) return;
    queueSync();
  });

  document.addEventListener('fleximaa:collection-grid-rendered', () => { init(); queueSync(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
